import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { pxToRem } from '../../../utils/pxToRem';

export interface DiplomatCardProps {
  name: string;
  title: string;
  flagSrc: string;
  flagAlt: string;
}

export function DiplomatCard({ name, title, flagSrc, flagAlt }: DiplomatCardProps) {
  return (
    <Stack
      gap={pxToRem(12)}
      sx={{
        width: pxToRem(160),
        color: 'primary.main',
        alignItems: { mobile: 'center', laptop: 'flex-start' },
      }}
    >
      {/* Figma 382:168: 63px flag circle, 3px gold ring included in the size */}
      <Box
        component="img"
        src={flagSrc}
        alt={flagAlt}
        aria-hidden={flagAlt === '' ? 'true' : undefined}
        sx={{
          width: pxToRem(63),
          height: pxToRem(63),
          boxSizing: 'border-box',
          border: `${pxToRem(3)} solid`,
          borderColor: 'secondary.main',
          borderRadius: '50%',
          objectFit: 'cover',
          display: 'block',
        }}
      />
      <Stack gap={pxToRem(8)} sx={{ textAlign: { mobile: 'center', laptop: 'left' } }}>
        <Typography
          component="p"
          sx={{
            fontFamily: '"Roboto", sans-serif',
            fontWeight: 900,
            fontSize: pxToRem(16),
            lineHeight: pxToRem(20),
            textTransform: 'uppercase',
            margin: 0,
          }}
        >
          {name}
        </Typography>
        <Typography
          component="p"
          sx={{
            fontFamily: '"Roboto", sans-serif',
            fontWeight: 400,
            fontSize: { mobile: pxToRem(12), laptop: pxToRem(16) },
            lineHeight: pxToRem(20),
            textTransform: 'capitalize',
            margin: 0,
          }}
        >
          {title}
        </Typography>
      </Stack>
    </Stack>
  );
}
